<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between min-[525px]:items-center my-3">

  <h2>Agent Bookings</h2>
  <div *ngIf="reading" class="flex items-center flex-col">
    <div class="flex justify-start items-baseline">
      <div><p class="text-primary mr-4">Waiting</p></div>
      <div class="dot-flashing"></div>
    </div>
    <div class="mt-1">
      <p class="text-sm">
        Don't refresh the website till the process done!
      </p>
    </div>
  </div>
  <div class="flex flex-col-reverse min-[525px]:flex-row gap-2">
    <button *appHasAnyPrivilege="'AGENT_BOOKING_READ_EMAILS'" nz-button nzType="primary"
            nz-popconfirm
            nzPopconfirmTitle="This may take some times. Are you sure that want to start?"
            nzPopconfirmPlacement="bottom"
            (nzOnConfirm)="readEmails()"
            (nzOnCancel)="cancel()">Read Emails
    </button>
  </div>
</div>

<section id="inventory-records">

  <nz-card>
    <div class="flex flex-col gap-3">
      <div [ngClass]="loading ? 'hidden' : 'block'">
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col lg:flex-row sm:justify-between 2xl:items-center gap-4">
              <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                <!--                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">-->
                <!--                  <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input-->
                <!--                         placeholder="Search here"/>-->
                <!--                </nz-input-group>-->

                <!--                <ng-template #suffixIconSearchButton>-->
                <!--                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">-->
                <!--                    <span nz-icon nzType="search"></span>-->
                <!--                  </button>-->
                <!--                </ng-template>-->
                <!--                <nz-divider-->
                <!--                  class="hidden lg:block"-->
                <!--                  [nzType]="'vertical'"-->
                <!--                ></nz-divider>-->

                <nz-form-item class="flex flex-col xl:flex-row m-0" style="flex-wrap: nowrap;">
                  <nz-form-label class="text-start">Filter by Status</nz-form-label>
                  <nz-select [(ngModel)]="filterType" (ngModelChange)="search()" nzPlaceHolder="Select Status"
                             [nzAllowClear]="true">
                    <nz-option [nzValue]="'TRANSFER'" nzLabel="Transfer"></nz-option>
                    <nz-option [nzValue]="'RENT'" nzLabel="Rent"></nz-option>
                  </nz-select>
                </nz-form-item>
              </div>

              <div>
                <button nz-button nzBlock class="outline-button w-full md:w-5" (click)="resetSearch()">
                  Reset All
                </button>
              </div>

            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
        <div class="table-obj">
          <nz-table
            #basicTable [nzData]="bookingData" [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
            (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto',y:'550px' }"
            nzOuterBordered 
          >
            <thead>
            <tr>
              <!--              <th>Agent BookingId</th>-->
              <th>Agent Name</th>
              <th>Date and Time</th>
              <th>Agent Reference</th>
              <th>Booking Type</th>
              <th>Vehicle Category</th>
              <th>Status</th>
              <th>Created Date</th>
              <th>Expire Date</th>
              <th *appHasAnyPrivilege="'AGENT_BOOKING_ACCEPT,AGENT_BOOKING_REJECT'">Actions</th>

            </tr>
            </thead>
            <tbody>

            <tr *ngFor="let data of basicTable.data" class="align-baseline">
              <!--              <td>-->
              <!--                <a class="clickable-text"-->
              <!--                >{{ data.bookingId }}</a>-->
              <!--              </td>-->
              <td style="min-width: 150px; white-space: nowrap">{{ data?.booking?.bookingDetails?.agent ? data?.booking?.bookingDetails?.agent : '-' }}</td>
              <td style="min-width: 150px; white-space: nowrap">{{ data?.booking?.bookingDetails?.bookingReceivedDate ? (convertToDate(data?.booking?.bookingDetails?.bookingReceivedDate) | date: 'dd-MM-y | hh:mm:a') : '-' }}</td>
              <td style="min-width: 150px; white-space: nowrap">{{ data?.booking?.bookingDetails?.bookingReference ? data?.booking?.bookingDetails?.bookingReference : '-' }}</td>
              <td style="min-width: 150px; white-space: nowrap">{{ data?.type ? (data?.type | titlecase) : '-' }}</td>
              <td style="min-width: 150px; white-space: nowrap">{{ data?.booking?.tourDetails?.vehicleCategory ? data?.booking?.tourDetails?.vehicleCategory : '-' }}</td>
              <td style="min-width: 150px; white-space: nowrap">
                <nz-tag *ngIf="data?.status === 'ACCEPTED'" [nzColor]="'#3ab200'"
                        class="rounded-full"
                >Accepted
                </nz-tag
                >
                <nz-tag
                  *ngIf="data?.status === 'REJECTED'" class="rounded-full" [nzColor]="'#F3454C'"
                >Rejected
                </nz-tag>
                <nz-tag
                  *ngIf="data?.status === 'PENDING'"
                  [nzColor]="'#FF8C00'" class="rounded-full"
                >Pending
                </nz-tag>
              </td>
              <td style="min-width: 150px;">{{ data?.createdAt | date: 'dd-MM-y' }}</td>
              <td style="min-width: 150px;">{{ data?.expireAt ? (data?.expireAt | date: 'dd-MM-y') : '-' }}</td>
              <td style="min-width: 150px;" *appHasAnyPrivilege="'AGENT_BOOKING_ACCEPT,AGENT_BOOKING_REJECT'">
                  <div *ngIf="data?.status === 'PENDING'">
                    <button
                      class="outline-button more-dropdown"
                      nz-button
                      nz-dropdown
                      [nzDropdownMenu]="menu"
                      nzPlacement="bottomCenter"
                    >
                      <span nz-icon nzType="more" nzTheme="outline"></span>
                    </button>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu>

                          <li nz-menu-item
                              (click)="previewMail(data)" nz-button
                        >Preview Mail
                        </li>
                        <li *appHasAnyPrivilege="'AGENT_BOOKING_ACCEPT'" nz-menu-item
                            nz-popconfirm
                            nzPopconfirmTitle="Did you send the 'Booking Acceptance Feedback' to the agent before accepting this booking in the system?"
                            [nzOkText]="'Yes'" [nzCancelText]="'No'"
                            (nzOnCancel)="cancel()"
                            (nzOnConfirm)="navigateToAddBooking(data)"
                            style="color: green">
                          Accept
                        </li>
                        <li *appHasAnyPrivilege="'AGENT_BOOKING_REJECT'" nz-menu-item nz-popconfirm
                            nzPopconfirmTitle="{{'Are you sure you want to reject this booking'}}"
                            [nzOkText]="'Yes'" [nzCancelText]="'No'"
                            (nzOnCancel)="cancel()"
                            (nzOnConfirm)="rejectBooking(data)" nz-button nzDanger>Reject
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </div>
                  <div *ngIf="data?.status !== 'PENDING'">
                    -
                  </div>
              </td>
<!--              <td *ngIf="data?.status !== 'PENDING'">-->
<!--                - -->
<!--              </td>-->
            </tr>

            </tbody>
          </nz-table>
        </div>
      </div>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
      </div>
    </div>
  </nz-card>

</section>
